<template>
  <vue-content-loading v-bind="$attrs" :width="600" :height="160">
    <circle cx="70" cy="70" r="70" />
    <rect x="180" y="40" rx="2" ry="2" width="200" height="20" />
    <rect x="180" y="80" rx="2" ry="2" width="150" height="20" />
  </vue-content-loading>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'customer_loader',
  components: {
    VueContentLoading,
  },
};
</script>

<style scoped>

</style>
